<template>
  <div>
    <working-group-add
      :isEdit="true"
      @showSubsections="showSubsections"
    ></working-group-add>

    <working-group-subsections ref="subsectionComponent" />
  </div>
</template>

<script>
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import WorkingGroupAdd from "./WorkingGroupAdd.vue";
import WorkingGroupSubsections from "./WorkingGroupSubsections.vue";
import settingsStoreModule from "../settingsStoreModule";

export default {
  components: {
    WorkingGroupAdd,
    WorkingGroupSubsections,
  },

  setup() {
    const WORKING_GROUP_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(WORKING_GROUP_APP_STORE_MODULE_NAME))
      store.registerModule(
        WORKING_GROUP_APP_STORE_MODULE_NAME,
        settingsStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(WORKING_GROUP_APP_STORE_MODULE_NAME))
        store.unregisterModule(WORKING_GROUP_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {};
  },

  methods: {
    showSubsections(workingGroupId) {
      if (workingGroupId) {
        this.$nextTick(() => {
          this.$refs.subsectionComponent.openModal(workingGroupId);
        });
      }
    },
  },
};
</script>
